import { useQuery } from '@tanstack/react-query'
import type React from 'react'
import { aiSpendQuery } from '../api/assistant'

/* In linie, nu in od_ai.css: foaia aia e a portalului vechi, comuna cu el. */
const BAND: React.CSSProperties = { fontSize: 11, padding: '3px 12px', color: '#555', borderBottom: '1px solid #eee' }

const TONES: Record<string, React.CSSProperties> = {
  warn: { background: '#fff8e1', color: '#7a5a00' },
  cheap: { background: '#fff3e0', color: '#8a4b00' },
  stop: { background: '#fdecea', color: '#b42318', fontWeight: 600 },
}

/**
 * Banda de cost din sertarul lui Adam: cat a costat conversatia de acum si cat
 * a cheltuit omul luna asta, fata de alocarea lui (sau "unlimited"), in forma
 * aleasa pentru firma (USD, credite, sau fara sume - adminii platformei vad
 * mereu USD; hotarat pe server, `/assistant/spend`).
 *
 * Peste pragul de avertizare banda se coloreaza; cand bugetul e atins spune
 * limpede ce urmeaza: Adam e oprit, sau raspunde pe modelul cel mai ieftin.
 * Cu suma ascunsa raman numai mesajele.
 *
 * `pulse` se schimba dupa fiecare raspuns: banda se reciteste atunci, nu la
 * fiecare pas.
 */
export function AdamSpend({ conversationId, pulse, open }: { conversationId: number; pulse: number; open: boolean }) {
  const q = useQuery(aiSpendQuery(conversationId, pulse, open))
  const s = q.data

  if (!s) return null

  const hidden = s.form === 'hidden'
  const tone = s.state === 'stop' ? 'is-stop' : s.state === 'cheap' ? 'is-cheap' : s.state === 'warn' ? 'is-warn' : ''

  if (hidden && s.state === 'ok') return null

  return (
    <div
      className={`od-ai-spend ${tone}`.trim()}
      data-testid="adam-spend"
      role={s.state === 'ok' ? undefined : 'status'}
      style={{ ...BAND, ...(TONES[s.state] ?? {}) }}
    >
      {!hidden ? (
        <span className="od-ai-spend-nums">
          <span title="The cost of this conversation">
            This conversation: <strong>{s.conversation.text}</strong>
          </span>
          {' · '}
          <span title="What you spent this month, against your allowance">
            This month: <strong>{s.month.text}</strong> of {s.unlimited ? 'unlimited' : s.allowance.text}
            {!s.unlimited && s.pct !== null ? ` (${Math.round(s.pct)}%)` : ''}
          </span>
        </span>
      ) : null}
      {s.state !== 'ok' && s.text !== '' ? <span className="od-ai-spend-note"> {s.text}</span> : null}
    </div>
  )
}
